export default __webpack_public_path__ + "408df1c264364fd520aa8c50e581cdff.svg";